import { useState } from "react";
import { PageKonten14 } from './Page14_PettyCashDashboard';
import { PageKonten18 } from './Page18_JurnalPettyCash';
import { PageKonten19 } from './Page19_Anggaran';
import { PageKonten21 } from './Page20_MaintenanceAkun';
import { PageKonten22 } from './Page21_MaintenanceSubAkun';


// KONTAINER TAB (TAB DI ATAS)
export function PageKonten13({ globalOpsi, authIdentity = {}, token }) {
  const [activeTab, setActiveTab] = useState("tab1");
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaUser = String(authIdentity?.nama || "").trim();
  const isPusat = kodeCabangUser === "C-1";
  const namaCabang = (
    isPusat
      ? "Pusat"
      : (
        (Array.isArray(globalOpsi?.opsiCabang) ? globalOpsi.opsiCabang : []).find(
          (x) => String(x?.kode_cabang || "").trim() === kodeCabangUser
        )?.nama_cabang || kodeCabangUser || "-"
      )
  );
  const sharedAuthProps = { authIdentity };

  const tabs = isPusat ? [
    { id: "tab1", label: "Transaksi", subtitle: "Pencatatan aktivitas keuangan harian", accent: "TRX" },
    { id: "tab2", label: "Jurnal", subtitle: "Rekap jurnal dan penyesuaian transaksi", accent: "JNL" },
    { id: "tab3", label: "Anggaran", subtitle: "Proses Pengajuan dan Persetujuan Anggaran", accent: "ANG" },
    { id: "tab4", label: "Maintenance", subtitle: "Pemeliharaan data dukung keuangan", accent: "MNT" }] 
  : 
  [
    { id: "tab1", label: "Transaksi", subtitle: "Pencatatan aktivitas keuangan harian", accent: "TRX" },
    { id: "tab2", label: "Jurnal", subtitle: "Rekap jurnal dan penyesuaian transaksi", accent: "JNL" },
    { id: "tab3", label: "Anggaran", subtitle: "Proses Pengajuan dan Persetujuan Anggaran", accent: "ANG" },
  ];
  const activeTabMeta = tabs.find((tab) => tab.id === activeTab) || tabs[0];

  return (
    <div className="page-con-tabh otf-page">
      <div className="otf-header">
        <div className="otf-header-main">
          <h2 className="otf-title">{`Aktivitas Keuangan ${isPusat ? "Pusat" : "Cabang"}`}</h2>
        </div>
        <div className="otf-header-meta">
          <div className="otf-meta-item">
            <small>Cabang</small>
            <strong>{String(namaCabang || "-")}</strong>
          </div>
          <div className="otf-meta-item">
            <small>User</small>
            <strong>{String(namaUser || "-")}</strong>
          </div>
        </div>
      </div>

      <div className="container-con-tabh otf-shell">
        <div className="tabNav-con-tabh otf-tabs">
          {tabs.map(tab => (
            <button
              type="button"
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`otf-tab-btn ${activeTab === tab.id ? "is-active" : ""}`}
            >
              <span className="otf-tab-accent">{tab.accent}</span>
              <span className="otf-tab-copy">
                <strong>{tab.label}</strong>
                <small>{tab.subtitle}</small>
              </span>
            </button>
          ))}
        </div>

        <div className="content-con-tabh otf-content">
          <div className="otf-content-head">
            <div>
              <p className="otf-content-kicker mb-1">Menu Aktif</p>
              <h4 className="otf-content-title mb-1">{activeTabMeta.label}</h4>
              <p className="otf-content-subtitle mb-0">{activeTabMeta.subtitle}</p>
            </div>
          </div>
          {activeTab === "tab1" && (
            <div className="otf-tab-panel">
              <PageKonten14 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />
            </div>
          )}
          {activeTab === "tab2" && (
            <div className="otf-tab-panel">
              <PageKonten18 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />
            </div>
          )}
          {activeTab === "tab3" && (
            <div className="otf-tab-panel">
              <PageKonten19 token={token} globalOpsi={globalOpsi} {...sharedAuthProps} />
            </div>
          )}
          {activeTab === "tab4" && (
            <div className="otf-tab-panel">
              <PageKonten21 token = {token}/>
            </div>
          )}
          {false &&  <div className="row">
              <div className="col-md-5">
              <PageKonten21 token = {token} />
              </div>
              <div className="col-md-7">
              <PageKonten22 token = {token} />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
